
/**
 * CertProposalForm
 */
export default class CertProposalForm {

    // constructor
    constructor(selector) {
        let _this = this;
        this.$plugin = $(selector);
        if (this.$plugin.length === 0) {
            return false;
        }

        this.$form = this.$plugin.find('[data-certproposalform-section="form"]');
        this.$success = this.$plugin.find('[data-certproposalform-section="success"]');
        this.$error = this.$plugin.find('[data-certproposalform-section="error"]');

        this.init();

    }

    // on init
    init() {
        let vm = this;
        vm.$plugin.submit(function(event) {
            vm.onSubmit(event, this);
        });
    }

    // on submit
    onSubmit(event, el) {

        let $form = $(el);
        let vm = this;

        vm.$form.show();
        vm.$success.hide();
        vm.$error.hide();
        let serializedData = $form.serialize();
        vm.disableForm($form);

        console.log(serializedData);

        vm.request = window.xhrRequest({
            url: $form.attr('action'),
            method: 'POST',
            data: serializedData
        });
        vm.request.then((response) => {
            console.log(response);
            if (response.data.status === true) {
                vm.$form.hide();
                vm.$success.show();
            } else {
                vm.$error.show();
            }
        }).catch((e) =>{
            console.log(e);
        }).then(() => {
            vm.disableForm($form, false);
        });

        event.preventDefault();

    }

    // disable all form fields
    disableForm($form, disable = true) {
        let $selectors = $form.find('button, input, select, textarea');
        if (disable === true) {
            $selectors.attr('disabled', true);
        } else {
            $selectors.removeAttr('disabled');
        }
    }

}